<template>
  <div id="burger">
    <button id="data-menu-toggle" class="data-menu-toggle" :class="flg ? 'active':''" @click="change(flg)">
      <span class="menu-bar bar"></span>
    </button>
  </div>
</template>

<script>
  export default {
    name: "burger",
    props: {
      flg: {
        type: Boolean,  // 布尔值  default默认为true
        default: false
      }
    },
    data() {
      return {
        Flg: ''
      }
    },
    created() {

    },
    methods: {
      change(flg) {
        if (flg == false) {
          //  this.flg = true;
          this.$emit('childByValue', true)
          this.$parent.changeFlg(true);
        } else {
          // this.flg = false
          this.$emit('childByValue', false)
          this.$parent.changeFlg(false);
        }
      }
    }
  }
</script>

<style scoped>
  #burger {
    position: absolute;
    right: 20px;
    top: 26px;

  }

  .data-menu-toggle {
    position: relative;
    width: 24px;
    height: 18px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    margin-right: 10px;
  }

  /* 初始化样式 */
  .data-menu-toggle .menu-bar,
  .data-menu-toggle .menu-bar:before,
  .data-menu-toggle .menu-bar:after {
    display: block;
    position: absolute;
    width: 100%;
    height: 4px;
    background-color: black;
    transition: all ease-in-out .3s;
  }

  .data-menu-toggle .menu-bar.bar {
    top: 8px;
  }

  .data-menu-toggle .menu-bar.bar:before {
    content: "";
    top: -8px;
  }

  .data-menu-toggle .menu-bar.bar:after {
    content: "";
    top: 8px;
  }

  /* 激活样式 */
  .data-menu-toggle.active .bar {
    background-color: transparent;
  }

  .data-menu-toggle.active .bar:before {
    top: 0px;
    transform: rotate(45deg);
  }

  .data-menu-toggle.active .bar:after {
    top: 0px;
    transform: rotate(-45deg);
  }

</style>



// WEBPACK FOOTER //
// src/components/BurgerNav.vue